import type {FlexProps, StackProps} from '@tempo/core';
import {createContext} from '@deezer/react-utils';
import {Card, Flex, tempo} from '@tempo/core';

const FlipCardBackFront = tempo(Card, {
	baseStyle: {
		backfaceVisibility: 'hidden',
		bg: 'background.neutral.secondary.default',
		w: '100%',
		minW: '100%',
		border: 'solid 2px',
		borderColor: 'border.neutral.primary.default',
	},
});

const FlipCardContainer = tempo('div', {
	baseStyle: {
		position: 'relative',
		flexWrap: 'no-wrap',
		display: 'flex',
		alignItems: 'stretch',
		flexDirection: 'row',
		width: '100%',
		height: '100%',
		transition: 'transform 0.3s',
		transformStyle: 'preserve-3d',
		transformOrigin: 'top',
		transitionDelay: '600ms',
		transitionTimingFunction: 'cubic-bezier(0.550, 0.055, 0.675, 0.190)',
	},
});

export const RectoCard: React.FC<{children: React.ReactNode} & StackProps> = ({
	children,
	...props
}) => {
	const {isFlipped} = useCard();
	return (
		<FlipCardBackFront
			zIndex={isFlipped ? '-1' : '1'}
			pointerEvents={isFlipped ? 'none' : 'all'}
			{...props}
		>
			{children}
		</FlipCardBackFront>
	);
};

export const VersoCard: React.FC<{children: React.ReactNode} & StackProps> = ({
	children,
	...props
}) => {
	const {isFlipped} = useCard();
	return (
		<FlipCardBackFront
			pointerEvents={isFlipped ? 'all' : 'none'}
			zIndex={isFlipped ? '1' : '-1'}
			transform="rotateY(180deg) translateX(100%)"
			{...props}
		>
			{children}
		</FlipCardBackFront>
	);
};

export const [Provider, useCard] = createContext<{isFlipped: boolean}>({
	name: 'FlippedCard',
});

export const FlippingCard: React.FC<
	{
		isFlipped: boolean;
		children: React.ReactNode;
	} & FlexProps
> = ({children, isFlipped, ...props}) => {
	return (
		<Provider value={{isFlipped}}>
			<Flex w="100%" overflowX="hidden" {...props}>
				<FlipCardContainer
					transform={isFlipped ? 'rotateY(180deg)' : undefined}
				>
					{children}
				</FlipCardContainer>
			</Flex>
		</Provider>
	);
};
